import React, { StrictMode } from 'react';

import Context from './Context';
import Main from './Main';

export default function Index() {
  return (
    <StrictMode>
      <Context>
        <Main />
      </Context>
    </StrictMode>
  );
}
